import type { AvailablePaymentMethod } from '@paddle/paddle-js';

/**
 * Payment methods the Paddle checkout overlay may offer: every method Paddle.js
 * knows except `upi`, which we don't accept. Paddle still decides which of these
 * to show from the transaction currency, the customer's location and device —
 * this list only removes options, it can't add one Paddle wouldn't show.
 *
 * Kept in its own module (not `paddle.ts`) because tests mock the Paddle wrapper
 * wholesale. `satisfies` pins every entry to the SDK's union, so a renamed method
 * fails the build instead of silently dropping out of checkout. A method Paddle.js
 * adds later stays hidden until it is listed here.
 */
export const CHECKOUT_ALLOWED_PAYMENT_METHODS = [
  'alipay',
  'apple_pay',
  'bancontact',
  'blik',
  'card',
  'google_pay',
  'ideal',
  'kakao_pay',
  'mb_way',
  'naver_pay',
  'payco',
  'paypal',
  'pix',
  'samsung_pay',
  'saved_payment_methods',
  'south_korea_local_card',
  'wechat_pay',
] as const satisfies readonly AvailablePaymentMethod[];
